/** Logo mark + wordmark for headers and auth screens (brand: deep teal wordmark, ".com" omitted in-app). */
export function BrandLogo({ size = 28, wordmark = true }: { size?: number; wordmark?: boolean }) {
  return (
    <span className="inline-flex items-center gap-2">
      <img
        src={size > 96 ? '/brand/logo-mark-256.png' : '/brand/logo-mark-96.png'}
        alt=""
        width={size}
        height={Math.round(size * 1.09)}
        className="shrink-0"
      />
      {wordmark ? (
        <span
          className="text-brand"
          style={{
            fontWeight: 'var(--font-weight-heading)',
            fontSize: size * 0.75,
            letterSpacing: '-0.01em',
          }}
        >
          FewerBags
        </span>
      ) : null}
    </span>
  );
}
